module.exports = __webpack_public_path__ + "static/media/takeatWhiteLogo.65e7940d.svg";